// src/components/slack-connect-button/SlackConnectButton.tsx
import React, { useMemo } from "react";
import { useNovu } from "../../hooks/NovuProvider.js";
import { NovuUI } from "../NovuUI.js";
import { withRenderer } from "../Renderer.js";
import { DefaultSlackConnectButton } from "./DefaultSlackConnectButton.js";
import { jsx } from "react/jsx-runtime";
var SlackConnectButtonInternal = withRenderer((props) => {
  const { container, appearance, ...defaultProps } = props;
  const novu = useNovu();
  const options = useMemo(() => {
    return {
      container,
      appearance,
      options: novu.options
    };
  }, [container, appearance, novu.options]);
  return /* @__PURE__ */ jsx(NovuUI, { options, novu, children: /* @__PURE__ */ jsx(DefaultSlackConnectButton, { ...defaultProps }) });
});
SlackConnectButtonInternal.displayName = "SlackConnectButtonInternal";
var SlackConnectButton = React.memo((props) => {
  return /* @__PURE__ */ jsx(SlackConnectButtonInternal, { ...props });
});
SlackConnectButton.displayName = "SlackConnectButton";
export {
  SlackConnectButton
};
//# sourceMappingURL=SlackConnectButton.js.map